import {
  ActionType,
  RegionAndLocaleSet,
  ValidatedErrors,
  SetProductApiEnabledAction,
  SetPreorderPeriodAction,
  SetCurrentStateAction,
  CancelChangesAction,
  AddRegionAndLocaleSetAction,
  ToggleRegionAndLocaleSetEnabledAction,
  SetFormErrorsAction,
  SetIsSubmittingAction,
  Merchant,
} from './types';

export const setProductApiEnabled = (
  productApiEnabled: boolean,
): SetProductApiEnabledAction => {
  return {
    type: ActionType.SET_PRODUCT_API_ENABLED,
    payload: { productApiEnabled },
  };
};

export const setPreorderPeriod = (
  preorderPeriod: string,
): SetPreorderPeriodAction => {
  return {
    type: ActionType.SET_PREORDER_PERIOD,
    payload: { preorderPeriod },
  };
};

export const setCurrentState = (
  merchant: Merchant,
  regionAndLocaleSets: RegionAndLocaleSet[],
): SetCurrentStateAction => {
  return {
    type: ActionType.SET_CURRENT_STATE,
    payload: {
      currentState: {
        productApiEnabled: merchant.productApiEnabled,
        preorderPeriod: merchant.preorderPeriod,
        regionAndLocaleSets: regionAndLocaleSets,
      },
    },
  };
};

export const cancelChanges = (): CancelChangesAction => {
  return {
    type: ActionType.CANCEL_CHANGES,
  };
};

export const addRegionAndLocaleSet = (
  regionAndLocaleSet: RegionAndLocaleSet,
): AddRegionAndLocaleSetAction => {
  return {
    type: ActionType.ADD_REGION_AND_LOCALE_SET,
    payload: { regionAndLocaleSet },
  };
};

export const toggleRegionAndLocaleSetEnabled = (
  regionAndLocaleSet: RegionAndLocaleSet,
): ToggleRegionAndLocaleSetEnabledAction => {
  return {
    type: ActionType.TOGGLE_REGION_AND_LOCALE_SET_ENABLED,
    payload: { regionAndLocaleSet },
  };
};

export const setFormErrors = (
  errors: Record<string, ValidatedErrors>,
): SetFormErrorsAction => {
  return {
    type: ActionType.SET_FORM_ERRORS,
    payload: { formErrors: errors },
  };
};

export const setIsSubmitting = (
  isSubmitting: boolean,
): SetIsSubmittingAction => {
  return {
    type: ActionType.SET_IS_SUBMITTING,
    payload: { isSubmitting },
  };
};
